import { TypedUseSelectorHook, useSelector } from 'react-redux';
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import { rootReducer } from './rootReducer';

export type AppState = ReturnType<typeof rootReducer>;

export const useTypedSelector: TypedUseSelectorHook<AppState> = useSelector;
